import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';
import { SCHEDULED_MESSAGES_BASE_QUERY_KEY } from './scheduledMessagesQuery';

type CancelScheduledMessageMutationArgs = {
  scheduledMessageUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, CancelScheduledMessageMutationArgs>,
  'mutationFn' | 'mutationKey'
>;

const cancelScheduledMessage = ({
  scheduledMessageUid,
}: CancelScheduledMessageMutationArgs) => {
  return API.post<{}, BaseErrorResponse>(
    `/api/internal/triggers/scheduled-messages/cancel/${scheduledMessageUid}`,
  );
};

const useCancelScheduledMessageMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: cancelScheduledMessage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SCHEDULED_MESSAGES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useCancelScheduledMessageMutation;
